module.exports = __webpack_public_path__ + "img/portrait_tobi-hoffmann.abc452dc.jpg";